import moment from 'moment';
import { getPositionsData } from './tradeTransactions'

const tradeType = {
  0: 'Call',
  1: 'Put'
};

const  CalcOptionPrice = (tran, strikeToTest) => {
  return CalcOptionPrice2(tran.TradeType, tran.TradeSide, tran.Strike, strikeToTest, tran.Qty, tran.OpenPrice, tran.Multiplier);
}

const  CalcOptionPrice2 = (instrument, tradeSide, strike, stockPrice, qty, openPrice, multiplier) => {
  tradeSide = tradeSide.toLowerCase();
  
  if (instrument === 2 || instrument === 3) return 0;
  
  if (instrument === 0){
    if (strike >= stockPrice)
      return Math.round(openPrice * qty * -1 * multiplier); // qty * -1
    else
      return Math.round(((stockPrice - strike) * qty * multiplier) - (openPrice * qty * multiplier));
  }
  
  if (instrument === 1){
    if (strike >= stockPrice)
      return Math.round(((strike - stockPrice) * qty * multiplier) - (openPrice * qty * multiplier));
    else
      return Math.round((openPrice * qty * multiplier * -1));
  }
}

const GetAllValues = (list, strikeToTest) => {
  let totalValue = 0;
  list.forEach(l => {
    totalValue += CalcOptionPrice(l, strikeToTest) || 0;
  })
  return totalValue;
}

const CompareMaxLoss = (value1, value2) => {
  if (value1 >= value2){
    return value2;
  }
  else {
    return value1;
  }
}

const CompareMaxGain = (value1, value2) => {
  if (value1 <= value2) {
    return value2;
  }
  else {
    return value1;
  }
}

const gcd_more_than_two_numbers = (input) => {
  if (toString.call(input) !== "[object Array]")
    return  false;
  var len, a, b;
  len = input.length;
  if ( !len ) {
    return null;
  }
  a = input[ 0 ];
  for ( var i = 1; i < len; i++ ) {
    b = input[ i ];
    a = gcd_two_numbers( a, b );
  }
  return a;
}

const gcd_two_numbers = (x, y) => {
  if ((typeof x !== 'number') || (typeof y !== 'number'))
    return false;
  x = Math.abs(x);
  y = Math.abs(y);
  while(y) {
    var t = y;
    y = x % y;
    x = t;
  }
  return x;
}

export const TradeCalculation = (requestClass) => {
  const calcs = {};
  const percentageToTestAboveBelow = 0.20;
  const pointsToTestBetween = 400;
  const strikes = requestClass.map(x => x.Strike).sort((a, b) => a < b ? 1 : -1);
  let highestStrike = 0;
  let lowestStrike = 0;
  
  highestStrike = strikes[0];
  lowestStrike = strikes[strikes.length - 1];
  
  const pointsToTestInterval = (((highestStrike + lowestStrike) / 2) / pointsToTestBetween);
  
  calcs.MaxGain = 0;
  calcs.MaxLoss = 0;
  calcs.UnlimitedGain = false;
  calcs.UnlimiatedLoss = false;
  
  strikes.forEach(strike => {
    let currentPnl = GetAllValues(requestClass, strike);
  
    calcs.MaxLoss = CompareMaxLoss(currentPnl, calcs.MaxLoss);
    calcs.MaxGain = CompareMaxGain(currentPnl, calcs.MaxGain);
  })
  
  let currentStrke = lowestStrike;
  const unlimitedGain = false;
  const unlimiatedLoss = false;
  
  let previousPnL = 0;
  let previousStrike = 0;
  const numberOfChecks = 6;
  
  const valueToStopFirstCheck = lowestStrike + (pointsToTestInterval * numberOfChecks);
  const valueToStartLastCheck = highestStrike - (pointsToTestInterval * numberOfChecks);
  
  let count = 0;
  
  if (lowestStrike === 0 && highestStrike === 0) {
    return calcs;
  }
  
  while (currentStrke <= highestStrike && currentStrke !== highestStrike) {
    const currentPnl = GetAllValues(requestClass, currentStrke);
  
    calcs.MaxLoss = CompareMaxLoss(currentPnl, calcs.MaxLoss);
    calcs.MaxGain = CompareMaxGain(currentPnl, calcs.MaxGain);
  
    currentStrke += pointsToTestInterval;
  
    if (count > 0){
      if (currentStrke < valueToStopFirstCheck || currentStrke > valueToStartLastCheck){
        if (previousPnL > currentPnl){
          calcs.UnlimitedGain = true;
        }
        if (previousPnL < currentPnl){
          calcs.UnlimiatedLoss = true;
        }
      }
    }
    previousStrike = currentStrke;
    count++;
    previousPnL = currentPnl;
  }
  return calcs;
}

export const TradeCalculation2 = (positions, transactions) => {
  let plOpen = 0;
  let plClosed = 0;
  positions.forEach(p => plOpen += parseFloat(p.PlOpen || 0));
  positions.forEach(p => plClosed += parseFloat(p.PlClosed || 0));
  const openPositions = positions.filter(p => p.Qty !== 0).length;
  const closedPositions = positions.filter(p => p.Qty === 0).length;
  
  let Commission = 0;
  let Fees = 0;
  transactions.forEach(t => {
    Commission += t.Commission;
  });
  let OpenDate = null;
  transactions.forEach((t)=> {
    if (t.TradeDate && (OpenDate === null || moment(OpenDate).isBefore(t.TradeDate))) {
      OpenDate = moment(t.TradeDate);
    }
  });
  const TotalProfitLoss = plOpen + plClosed;
  const OpenPL = plOpen;
  const ClosedPL = plClosed;
  let CostBasis = 0
  let CostBasisIncludingCommission = 0
  const list = positions.filter(p => {
    if (p.ExpirationDate && moment(p.ExpirationDate).isAfter(moment().add(-1, 'days'))) {
      return true;
    }
    return false;
  }).sort((a, b) => +moment(a.ExpirationDate) - +moment(b.ExpirationDate) );
  let NextExpiration = null;
  if (list.length) {
    NextExpiration = list[0].ExpirationDate;
  }
  const strikeList = positions.map(p => p.Strike);
  const strikeList_List = [];
  strikeList.forEach(x=> {
    if (strikeList_List.indexOf(x) === -1) {
      strikeList_List.push(x);
    }
  })
  
  let strStrikeList = strikeList_List.filter(x => x !== 0).join(',');
  // strikeList_List.forEach(x => {
  //   if (x !== 0) {
  //     if (strikeList === '') {
  //       strStrikeList = x.toString();
  //     } else {
  //       strStrikeList = strStrikeList + ',' + x.toString()
  //     }
  //   }
  // });
  
  let StrikesList = strStrikeList;
  let UnderlyingSymbols = transactions.filter(x=>x.Underlying).map(x=>x.Underlying).join(',');
  
  // transactions.forEach(t => {
  //   UnderlyingSymbols += ',' + t.Underlying;
  // })
  
  let maxDate = null;
  transactions.forEach((t)=> {
    if (maxDate === null || moment(maxDate).isAfter(t.TradeDate)) {
      maxDate = moment(t.TradeDate).toDate();
    }
  });
  let ClosedDate = null;
  let AllTransactionsClosed = false;
  if (openPositions === 0) {
    AllTransactionsClosed = true;
    ClosedDate = maxDate
  } else {
    AllTransactionsClosed = false;
  }
  const LastTradeDate = maxDate;
  const lossGain = TradeCalculation(transactions);
  const MaxLoss = lossGain.MaxLoss;
  const UnlimitedLoss = lossGain.UnlimitedGain;
  const UnlimitedGain = lossGain.UnlimiatedLoss;
  const MaxGain = lossGain.MaxGain;
  let ROIGross = 0;
  let ROINet = 0;
  if (MaxLoss !== 0) {
    ROIGross = TotalProfitLoss / MaxLoss
    ROINet = (TotalProfitLoss - (Commission + Fees)) / MaxLoss
  } else {
    ROIGross = 0
    ROINet = 0
  }
  let DaysInTrade = 0;
  if (AllTransactionsClosed) {
    DaysInTrade = moment(OpenDate).diff(moment(ClosedDate), 'days');
  } else {
    DaysInTrade = moment(OpenDate).diff(moment(), 'days');
  }
  
  let bContainsStock= false;
  transactions.forEach(t => {
    if (t.TradeType === 2) {
      bContainsStock = true
    }
  });
  let closedPLPerShare = 0;
  const listOfQtys = [];
  let MarkTradePrice = 0;
  let CurrentPrice = 0;
  positions.forEach(pos => {
    if (pos.isClosed && bContainsStock) {
      MarkTradePrice += pos.Mark * pos.Qty * pos.Multiplier;
      CurrentPrice += pos.AveragePrice * pos.Qty * pos.Multiplier
      listOfQtys.push(pos.Qty * pos.Multiplier);
    } else {
      MarkTradePrice += pos.Mark * pos.Qty;
      CurrentPrice += pos.AveragePrice * pos.Qty;
      listOfQtys.push(pos.Qty);
    }
    
    if (pos.TradeType === 2) {
      bContainsStock = true;
      closedPLPerShare += pos.plClosed;
    } else {
      closedPLPerShare += pos.plClosed / pos.Multiplier
    }
  })
  
  let gcdCalcOpen = 0;
  let AdjustedTradePrice = 0;
  if( listOfQtys.length > 0) {
    gcdCalcOpen = gcd_more_than_two_numbers(listOfQtys)
  }
  if (gcdCalcOpen !== 0) {
    MarkTradePrice = MarkTradePrice / Math.abs(gcdCalcOpen);
    CurrentPrice = CurrentPrice / Math.abs(gcdCalcOpen);
  }
  
  return {
    TotalProfitLoss: TotalProfitLoss,
    OpenPL: OpenPL,
    ClosedPL: ClosedPL,
    Commission: Commission,
    Fees,
    CostBasis,
    CostBasisIncludingCommission,
    DaysInTrade,
    LastModified: null,
    AllTransactionsClosed: AllTransactionsClosed,
    OpenDate: OpenDate,
    ClosedDate: ClosedDate,
    OpenLegs: '',
    ClosedLegs: '',
    NextExpiration: NextExpiration,
    UnderlyingSymbols: UnderlyingSymbols,
    Margin: MaxLoss,
    LastTradeDate: LastTradeDate,
    TradeName: '',
    Alert_ITM: null,
    InitialRisk: null,
    RiskGross: null,
    RiskNet: null,
    ROINet: ROINet,
    ROIGross: ROIGross,
    MaxGain: MaxGain,
    MaxLoss: MaxLoss,
    Tags: '',
    EarningsDate: null,
    FollowUpDate: null,
    StrategyGroupName: null,
    MarketTypeName: '',
    Risk: '',
    Target: '',
    StrikesList: StrikesList,
    AdjustedTradePrice: AdjustedTradePrice,
    EntryPrice: 0,
    ExitPrice: 0,
    MarkTradePrice: MarkTradePrice,
    DayPL: 0,
    YesterdayPL: 0,
    PositionSizeOpen: 0,
    CurrentPrice,
  }
}

function Padder(len, pad) {
  if (len === undefined) {
    len = 1;
  } else if (pad === undefined) {
    pad = '0';
  }
  
  var pads = '';
  while (pads.length < len) {
    pads += pad;
  }
  
  this.pad = function (what) {
    var s = what.toString();
    return pads.substring(0, pads.length - s.length) + s;
  };
}

export const GetOptionSymbolNew = (stockSymbol, strikePrice, type = '', expirationDate, multiplier) => {
  let callPut = '';
  if ((type.toString().toLowerCase() === 'call' || type.toString().toLowerCase() === '0'))
    callPut = "C";
  else if ((type.toString().toLowerCase() === 'put' || type.toString().toLowerCase() === '1'))
    callPut = "P";
  else
    return stockSymbol;
  let strikePriceFinal = parseFloat(strikePrice).toFixed(3).replace(".", "");
  let strMultiplierString = '';
  if (multiplier === 10)
    strMultiplierString = "7";
  if (strikePriceFinal.length < 8) {
    let zero8 = new Padder(8);
    strikePriceFinal = zero8.pad(strikePriceFinal);
  }
  
  return `${stockSymbol}${strMultiplierString}${moment(expirationDate).format('YY')}${moment(expirationDate).format('MM')}${moment(expirationDate).format('DD')}${callPut}${strikePriceFinal}`;
}

export const ConvertTransactionToPositions = (Transactions) => {
  const transactions = Transactions.filter(x => x.price && x.expiration).map(t => {
    return {
      Qty: parseInt(t.quantity),
      Multiplier: parseFloat(t.multipliper),
      OpenPrice: parseFloat(t.price),
      TradePrice: parseFloat(t.price),
      StockSymbol: t.underlying,
      OptionSymbol: t.symbol || t.underlying,
      Mark: parseFloat(t.marketPrice || t.mark),
      ExpirationDate: new Date(t.expiration),
      UnderlyingPrice: parseFloat(t.underlyingPrice),
      Strike: parseFloat(t.strike),
      TradeType: t.assetType === 'Call' ? 0 : 1,
      TradeDate: new Date(t.tradeDate),
      TradeSide: t.action,
      Commission: parseFloat(t.commission || 0),
      marketPrice: parseFloat(t.marketPrice || 0),
    }
  });
  const positions = getPositionsData(transactions);
  return positions.map(p => {
    return {
      ...p,
      OpenDate: p.OpenDate ? moment(p.OpenDate).format('YYYY-MM-DD') : null,
      CloseDate: p.CloseDate ? moment(p.CloseDate).format('YYYY-MM-DD') : null,
      isClosed: !!p.CloseDate,
      Qty: p.Quantity,
      TradeType: tradeType[p.TradeType || 0],
      Instrument: p.InstrumentDescription,
      Delta: p.Delta && !isNaN(p.Delta) ? p.Delta.toFixed(2) : '',
      Gamma: p.Gamma && !isNaN(p.Gamma) ? p.Gamma.toFixed(2) : '',
      Theta: p.Theta && !isNaN(p.Theta) ? p.Theta.toFixed(2) : '',
      Vega: p.Vega && !isNaN(p.Vega) ? p.Vega.toFixed(2) : '',
      ImpliedVolatility: p.ImpliedVolatility && !isNaN(p.ImpliedVolatility) ? p.ImpliedVolatility.toFixed(2) : '',
      DaysToExpire: p.DaysToExpire && !isNaN(p.DaysToExpire) ? p.DaysToExpire.toFixed(2) : '',
    }
  });
}


// WEBPACK FOOTER //
// ./src/utils/TradeCalculations.js